<template>
    <!-- if we have a loading state then add a "loader" class to the element  -->
    <table :class="{loader: $store.getters.loading}" class="table shop_table cart ">
        <thead>
        <tr>
            <th class="product-remove">&nbsp;</th>
            <th class="product-thumbnail">&nbsp;</th>
            <th class="product-name">Product</th>
            <th class="product-price">Price</th>
            <th class="product-units">Units</th>
            <th class="product-quantity">Quantity</th>
            <th class="product-subtotal">Subtotal</th>
        </tr>
        </thead>
        <tbody>

        <tr
            :class="editProduct && editProduct.uid === item.uid ? 'edit_cart_item' : 'cart_item'"
            v-for="(item, index) in $store.getters.cartItems">
            <template v-if="!editProduct || editProduct.uid !== item.uid" >
                <td class="product-remove">
                    <a @click="handleRemoveFromCart(item)" href="javascript:" class="remove">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#9daca1" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve">
                            <g><path d="M500,850c12.9,0,23.3-10.4,23.3-23.3v-490c0-12.9-10.4-23.3-23.3-23.3c-12.9,0-23.3,10.4-23.3,23.3v490C476.7,839.5,487.1,850,500,850z M383.3,850c12.9,0,23.3-10.4,23.3-23.3l-23.3-490c0-12.9-10.4-23.3-23.3-23.3c-12.9,0-23.3,10.4-23.3,23.3l23.3,490C360,839.5,370.4,850,383.3,850z M920,173.3H710v-70c0-51.5-41.8-93.3-93.3-93.3H383.3c-51.5,0-93.3,41.8-93.3,93.3v70H80c-12.9,0-23.3,10.4-23.3,23.3c0,12.9,10.4,23.3,23.3,23.3h97.9l65.5,676.7c0,51.6,41.8,93.3,93.3,93.3h326.7c51.6,0,93.3-41.8,93.3-93.3L822.1,220H920c12.9,0,23.3-10.5,23.3-23.3C943.3,183.8,932.9,173.3,920,173.3z M336.7,103.3c0-25.8,20.9-46.7,46.7-46.7h233.3c25.8,0,46.7,20.9,46.7,46.7v70H336.7V103.3z M710,896.7c0,25.8-20.9,46.7-46.7,46.7H336.7c-25.8,0-46.7-20.9-46.7-46.7L224.5,220h551L710,896.7z M616.7,850c12.9,0,23.3-10.4,23.3-23.3l23.3-490c0-12.9-10.4-23.3-23.3-23.3c-12.9,0-23.3,10.4-23.3,23.3l-23.3,490C593.3,839.5,603.8,850,616.7,850z"></path></g>
                        </svg>
                    </a>
                </td>

                <td class="product-thumbnail">
                    <div class="d-flex d-lg-block">
                        <a :href="item.publish_url">
                        <wrap-image :prop-image="item.image" :prop-class="getProductCategorySlug(item)"/>
                    </a>
                    <div class="product-name-mobile">
                        <a :href="item.publish_url">{{ item.title }}</a>
                        <br>
                        <span class="item-sku">SKU: {{ item.sku }}</span>
                    </div>
                    </div>
                </td>

                <td class="product-name" data-title="Product:" v-if="getProduct(item)">
                    <div class="product-name-desk">
                        <div class="page-cart-category">{{ getProduct(item).categories[0].name=='Uncategorized'?'':getProduct(item).categories[0].name }}</div>
                        <a :href="item.publish_url">{{ item.title }}</a>
                        <span class="item-sku">SKU: {{ item.sku }}</span>
                    </div>
                    <div class="product-variation" v-if="['variable', 'huge_variations'].includes(item.type)">
                        <dl class="variation">
                            <template v-for="attribute in getProduct(item).attributes">
                                <dt class="variation-WIDTH">{{ attribute.name }}:</dt>
                                <dd class="variation-WIDTH">
                                    <p>{{optionName(attribute, item.options)}}</p>
                                </dd>
                                <template class="variation" v-if="item.extra_attribute">
                                    <template v-for="(option, index) in item.extra_attribute_options">
                                        <dt class="variation-WIDTH">{{ item.extra_attribute.attribute.name  + ' ' + (parseInt(index) + 1) }}:</dt>
                                        <dd class="variation-WIDTH">
                                            <p>{{option.name}}</p>
                                        </dd>
                                    </template>
                                </template>
                                <!-- <template class="variation" v-if="item.extra_attribute">
                                    <template v-for="(option, index) in item.extra_attribute.options">
                                        <dt class="variation-WIDTH">{{ item.extra_attribute.attribute.name  + ' ' + (parseInt(index) + 1) }}:</dt>
                                        <dd class="variation-WIDTH">
                                            <p>{{option.name}}</p>
                                        </dd>
                                    </template>
                                </template> -->
                            </template>
                        </dl>
                        <div class="edit_cart">
                            <button v-if="item.type === 'variable'" type="button" v-on:click="editProduct = item" class="product_edit_btn tn_btn_light" >
                            <i class="fas fa-edit"></i>
                            Edit Options
                        </button>
                        </div>

                    </div>
                    <dq-attributes v-if="item.type === 'dq_product'" :product="item"></dq-attributes>
                </td>

                <td class="product-price" data-title="Price:">
                        <span class="price-amount">
                            <!-- <bdi>{{ priceFormatter(item.price) }} <span class="product-units-mobile">{{ item.units }}</span></bdi> -->
                            <bdi>{{ priceFormatter(item.price) }}</bdi>
                            <div class="price-inp" v-if="isAdmin">
                                <input type="text" class="input-text qty text" v-on:change="setCustomPrice($event, item)" :value="item.price">
                            </div>
                        </span>
                </td>

                <td class="product-units" data-title="Units:"><span>{{ item.units || 'each' }}</span></td>

                <td class="product-quantity" data-title="Quantity:">
                    <span>
                        <div class="quantity">
                            <input type="number" :disabled="item.is_group_of" class="input-text qty text" min="1" @focusout="onQuantityInput($event, item)" v-on:change="updateQuantity($event, item)" :value="item.quantity">
                        </div>
                    </span>
                </td>

                <td class="product-subtotal" data-title="Subtotal:">
                        <span class="price-amount">
                            <bdi>{{ !item.price ? 'FREE' : item.price * item.quantity > 0 ? priceFormatter(item.price * item.quantity) : "FREE" }}</bdi>
                        </span>
                </td>
            </template>

            <td v-if="editProduct && editProduct.uid === item.uid" colspan="7">
                <product-edit-section
                    :prop-cart-item="editProduct"
                    :prop-cart-index="index"
                    v-on:onSuccess="editProduct = null"
                    v-on:onCancel="updateCancel(item,index)"
                ></product-edit-section>
            </td>
        </tr>

        <tr class="cart_coupon">
            <td colspan="7" class="actions">
                <div class="coupon">
                    <input type="text" name="coupon_code" class="input-text" v-model="code" placeholder="Coupon code">
                    <button v-on:click="handleGetCoupon" class="apply_btn" name="apply_coupon" value="Apply coupon">Apply coupon</button>
                    <button v-on:click="emptyCart" v-if="isAdmin" class="d-md-block d-none empty_cart">Empty cart</button>
                </div>
            </td>
        </tr>
        </tbody>
    </table>
</template>


<script>
import {mapActions, mapGetters} from "vuex"
import WrapImage from "../WrapImage";
import ProductEditSection from "../product/ProductEditSection";

export default {
    name: 'cart-list-section',
    components: {ProductEditSection, WrapImage},
    data() {
      return {
          editProduct: null,
          isShippingUpdate: false,
          code: null
      }
    },
    computed: {
        ...mapGetters(['isAdmin', 'cartItems']),
    },
    mounted()
    {
        this.checkCartItems();
    },
    methods: {
        ...mapActions(['removeFromCart', 'calculateShipping', 'updateCartQuantity', 'saveCart', 'addNote', 'getCoupon', 'emptyCart', 'emptyNotes', 'updateCustomPrice', 'cartMinQtyNote','checkCartItems',"beforeCalcGroundFreight",'linkedProducts']),
        dataLayerUpdateItem(selectedVariation)
        {
            window.dataLayer = window.dataLayer || [];

            if(this.$store.state.cart.items.length)
            {
                let products = [];
                let items = [];

                this.$store.state.data_layer_add_to_cart.ecommerce.value = selectedVariation ? (selectedVariation.quantity*selectedVariation.price).toFixed(2) : "0.00";

                let options =  selectedVariation ? Object.values(selectedVariation.options) : "";
                let category = "";

                if(typeof(selectedVariation.categories) != "undefined" && selectedVariation.categories !== null)
                    category =  selectedVariation && selectedVariation.categories.length > 0 ? selectedVariation.categories[0].meta_title : "";

                products[0] = {};
                products[0].brand = "";
                products[0].category = category;
                products[0].id = selectedVariation ? selectedVariation.sku : "";
                products[0].name = selectedVariation ? selectedVariation.title : "";
                products[0].price = selectedVariation ? parseFloat(selectedVariation.price) : "";
                products[0].quantity = this.quantity;
                products[0].stocklevel = "";
                products[0].variant = options ? options.join(",") : "";

                items[0] = {};
                items[0].google_business_vertical = "retail";
                items[0].id = selectedVariation ? selectedVariation.sku : "";
                items[0].item_brand = "";
                items[0].item_category = category;
                items[0].item_id = selectedVariation ? selectedVariation.sku : "";
                items[0].item_name = selectedVariation ? selectedVariation.title : "";
                items[0].item_variant = options ? options.join(",") : "";
                items[0].price = selectedVariation ? parseFloat(selectedVariation.price) : "";
                items[0].quantity = this.quantity;

                this.$store.state.data_layer_add_product_to_cart_eec.ecommerce.add.products = products;
                this.$store.state.data_layer_add_to_cart.ecommerce.items = items;

                // for(let i=0; i<obj1Keys.length; i++) {
                //     window.dataLayer[i] = window.dataLayer[obj1Keys[i]];
                // }

                // for(let i=0; i<obj2Keys.length; i++) {
                //     window.dataLayer[i+obj1Keys.length] = this.$store.getters.updateDetailsDataLayer[obj2Keys[i]];
                // }

                window.dataLayer.push(this.$store.getters.updateDetailsDataLayer[0]);
                window.dataLayer.push(this.$store.getters.updateDetailsDataLayer[1]);
            }
            else
            {
                this.$store.state.data_layer_change_detail_view_eec.ecomm_prodid = "";
                this.$store.state.data_layer_change_detail_view_eec.ecomm_totalvalue = "0.00";
                this.$store.state.data_layer_view_item.ecommerce.value = "0.00";
            }
        },
        updateCancel(item,index)
        {


            for(let i = 0; i < Object.keys(item.options).length; i++) {
                let key = Object.keys(item.options)[i];
                let value = item.options[key];
                if(key === 'sample-kit-size') {
                    const numberIndex = value.match(/[0-9]/g);
                    const dataArray = Object.entries(item.extra_attribute_options)
                    const top2Objects = dataArray.slice(0, numberIndex[0]);
                    this.$store.getters.cartItems[index].extra_attribute.options = Object.fromEntries(top2Objects);
                    this.$store.getters.cartItems[index].extra_attribute_options = Object.fromEntries(top2Objects);
                    break
                }
            }

            this.editProduct = null;
            item.editQuantity = item.quantity
            return this.editProduct;
        },
        dataLayerRemoveItem()
        {
            window.dataLayer = window.dataLayer || [];

            let products = [];
            let items = [];

            products[0] = {};
            products[0].brand = "";
            products[0].category = "";
            products[0].id = "";
            products[0].name = "";
            products[0].price = "";
            products[0].quantity = "";
            products[0].stocklevel = "";
            products[0].variant = "";

            items[0] = {};
            items[0].google_business_vertical = "retail";
            items[0].id = "";
            items[0].item_brand = "";
            items[0].item_category = "";
            items[0].item_id = "";
            items[0].item_name = "";
            items[0].item_variant = "";
            items[0].price = "";
            items[0].quantity = "";

            this.$store.state.data_layer_add_remove_from_cart_eec.ecommerce.remove.products = products;
            this.$store.state.data_layer_remove_from_cart.ecommerce.items = items;

            // for(let i=0; i<obj1Keys.length; i++) {
            //     window.dataLayer[i] = window.dataLayer[obj1Keys[i]];
            // }

            // for(let i=0; i<obj2Keys.length; i++) {
            //     window.dataLayer[i+obj1Keys.length] = this.$store.getters.removeDetailsDataLayer[obj2Keys[i]];
            // }

            window.dataLayer.push(this.$store.getters.removeDetailsDataLayer[0]);
            window.dataLayer.push(this.$store.getters.removeDetailsDataLayer[1]);

        },
        onQuantityInput($event, item) {
            let quantity = Number(Math.ceil($event.target.value)) <= 0 ? 1 : Number(Math.ceil($event.target.value))

            // if(quantity && quantity > 9999) {
            //     quantity = 9999;
            // }

            if(this.isFunctionalityForAdminEnabledMethod(item) || !this.$store.getters.auth){
                if(item.min_quantity && item.min_quantity > quantity) {
                    if(!item.allow_combination) {
                        quantity = item.min_quantity
                    }
                }

                quantity = this.getQtyGrouped(quantity, item)

                if(item.max_quantity && item.max_quantity < quantity) {
                    quantity = item.max_quantity
                }
            }

            $event.target.value = quantity
        },
        getQtyGrouped(qty, item) {
            if(item.group_of && item.group_of > 1 && (qty / item.group_of) % 1 !== 0) {

               if (qty > item.quantity) {
                   qty = qty - qty % item.group_of + item.group_of
               } else if (qty < item.quantity) {
                   qty = item.quantity - item.quantity % item.group_of - item.group_of
               }
                return qty
            }
            return qty
        },
        updateQuantity($event, item) {

            this.checkCartItems();
            let quantity = Number(Math.ceil($event.target.value)) <= 0 ? 1 : Number(Math.ceil($event.target.value))

            if(this.isFunctionalityForAdminEnabledMethod(item) || !this.$store.getters.auth) {
                if(item.min_quantity && item.min_quantity > quantity) {
                    if(!item.allow_combination) {
                        quantity = item.min_quantity
                    }
                }


                quantity = this.getQtyGrouped(quantity, item)

                if(item.max_quantity && item.max_quantity < quantity) {
                    quantity = item.max_quantity
                }
            }

            if(!quantity) {
                quantity = 1;
            }

            // if(quantity && quantity > 9999) {
            //     quantity = 9999;
            // }
            $event.target.value = quantity;
            this.updateCartQuantity(Object.assign(item, {quantity})).then(res => {
                this.dataLayerUpdateItem(item);
                if(!this.isShippingUpdate) {
                    this.isShippingUpdate = true
                    setTimeout( () => {
                        this.beforeCalcGroundFreight().then(res => {
                            this.isShippingUpdate = false
                            this.saveCart({page: 'cart'})
                            this.cartMinQtyNote()
                        })
                    }, 2000)
                }
                // this.saveCart({page: 'cart'})
            })


        },
        setCustomPrice($event, item){
            this.checkCartItems();
            let customPrice = parseFloat($event.target.value).toFixed(2)
            this.updateCustomPrice(Object.assign(item, {customPrice})).then(res => {
                this.dataLayerUpdateItem(item);
                if(!this.isShippingUpdate) {
                    this.isShippingUpdate = true
                    setTimeout( () => {
                        this.beforeCalcGroundFreight().then(res => {
                            this.isShippingUpdate = false
                        })
                    }, 2000)
                }
                this.saveCart({page: 'cart'})
            })
        },
        handleRemoveFromCart(item) {
            this.removeFromCart(item).then(res => {
                this.dataLayerRemoveItem(item);
                this.saveCart({page: 'cart'})
                this.linkedProducts(4)
            })
            this.cartMinQtyNote()
        },
        handleGetCoupon() {
            this.getCoupon(this.code).then(res => {
                this.saveCart({page: 'cart'})
            })
            this.cartMinQtyNote()
        },
        optionName(attribute, options) {
            const option = attribute.options.find(i => i.slug === options[attribute.slug])
            return (option && option.name) || ''
        },
        getProduct(item) {
            return this.$store.state.app.products.find(i => i.id === item.id)
        },
        getProductCategorySlug(item) {
            let products = this.$store.state.app.products;
            let product = products.length ? this.$store.state.app.products.find(i => i.id === item.id) : null

            if(product)
                return product && product.categories[0].name=='Uncategorized'? '': 'make-'+product.categories[0].slug
            else
                return ""
        },
        isFunctionalityForAdminEnabledMethod(item) {
            return item.enable_functionality_for_admin && this.$store.getters.auth
        }
    },
}
</script>
